import React from "react";
import PropTypes from "prop-types";

// "N left" counter shown under a capped text input (§6.1). Quiet until the player nears the
// cap: hidden while there is plenty of room, neutral as it fills, warning near the limit.
// Thresholds are relative to maxLength so it works with any server-provided cap.
const REVEAL_WITHIN = 60;
const WARN_WITHIN = 15;

const CharCounter = ({ value = "", maxLength, className = "", nudge = null }) => {
  const remaining = maxLength - value.length;

  if (remaining > REVEAL_WITHIN) {
    return null;
  }

  const warning = remaining <= WARN_WITHIN;

  return (
    <span
      className={`char-counter${warning ? " char-counter--warning" : ""} ${className}`.trim()}
      aria-live="polite"
    >
      {remaining}
      {/* E11: one calm craft nudge only once the writer is near the cap - never whimsy. */}
      {warning && nudge && <span className="char-counter__nudge"> {nudge}</span>}
    </span>
  );
};

CharCounter.propTypes = {
  value: PropTypes.string,
  maxLength: PropTypes.number.isRequired,
  className: PropTypes.string,
  nudge: PropTypes.string,
};

export default CharCounter;
